import Discover from './discover'
import Store from './store'
import ProductDetails from './productDetails'
import About from './About'

export default [
    Discover, 
    Store,
    ProductDetails,
    About
]